import { Request } from '~/infrastructure/mam/ApiClient';

export type ERPPackResponse = {
	erpPack: {
		erpSession: {
			id: string;
		};
		id: string;
	};
};

export enum ERPPackError {
	'internal-server-error' = 'internal-server-error',
}

export const getHumanReadableErrorCode = (codes: Set<string>): string | null => {
	return null;
};

export class ERPPackRequest implements Request<ERPPackResponse, ERPPackResponse> {
	public readonly knownErrorCodes = Object.values(ERPPackError);
	public readonly path: string;
	public readonly method = 'post';
	public readonly body: BodyInit | null = null;

	public constructor(userId: string, virtualPackId: string) {
		this.path = `users/${userId}/erp/packages`;
		this.body = JSON.stringify({ virtualPackId });
	}

	decode(response: ERPPackResponse) {
		return response;
	}
}
